"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectSaraiva = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _utils = require("../utils");

var _Menu = _interopRequireDefault(require("../menu/Menu"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    input: {
      width: '100%',
      '& .MuiSelect-select:focus': {
        backgroundColor: 'white !important'
      },
      '& .MuiOutlinedInput-input': {
        padding: '18px 32px 18px 14px'
      }
    },
    select: {
      padding: '18px, 14px'
    },
    textError: {
      color: theme.palette.error.main
    },
    label: {
      '&.Mui-focused': {
        color: theme.palette.error.main
      }
    },
    cascadeInput: {
      cursor: 'pointer'
    },
    cascadeInputLabel: {
      zIndex: 0,
      '&.MuiInputLabel-shrink': {
        zIndex: 1
      }
    }
  };
});

var SelectSaraiva = function SelectSaraiva(_ref) {
  var disabled = _ref.disabled,
      error = _ref.error,
      label = _ref.label,
      helperText = _ref.helperText,
      iconComponent = _ref.iconComponent,
      children = _ref.children,
      onChange = _ref.onChange,
      value = _ref.value,
      size = _ref.size,
      className = _ref.className,
      cascade = _ref.cascade,
      selectedLabel = _ref.selectedLabel;
  var cascadeInputRef = (0, _react.useRef)();
  var cascadeRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var classes = useStyles();

  function onClickCascadeInput(e) {
    cascadeInputRef.current.focus();
    setAnchorEl(e.currentTarget);
  }

  if (cascade) {
    var _cascadeRef$current, _cascadeRef$current$g, _cascadeRef$current$g2, _cascadeRef$current2, _cascadeRef$current2$, _cascadeRef$current2$2, _cascadeRef$current3, _cascadeRef$current3$, _cascadeRef$current3$2;

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      label: value ? selectedLabel : label,
      variant: "outlined",
      helperText: helperText,
      value: value,
      onClick: onClickCascadeInput,
      className: className,
      ref: cascadeRef,
      InputProps: {
        endAdornment: /*#__PURE__*/_react.default.createElement(_icons.ArrowDropDown, null),
        readOnly: true,
        className: classes.cascadeInput
      },
      inputProps: {
        ref: cascadeInputRef,
        className: classes.cascadeInput
      },
      InputLabelProps: {
        className: classes.cascadeInputLabel
      }
    }), /*#__PURE__*/_react.default.createElement(_Menu.default, {
      open: Boolean(anchorEl),
      anchorEl: anchorEl,
      onClose: function onClose() {
        return setAnchorEl();
      },
      onClick: function onClick() {
        return setAnchorEl();
      },
      style: {
        minWidth: cascadeRef === null || cascadeRef === void 0 ? void 0 : (_cascadeRef$current = cascadeRef.current) === null || _cascadeRef$current === void 0 ? void 0 : (_cascadeRef$current$g = _cascadeRef$current.getBoundingClientRect) === null || _cascadeRef$current$g === void 0 ? void 0 : (_cascadeRef$current$g2 = _cascadeRef$current$g.call(_cascadeRef$current)) === null || _cascadeRef$current$g2 === void 0 ? void 0 : _cascadeRef$current$g2.width,
        marginTop: -(cascadeRef === null || cascadeRef === void 0 ? void 0 : (_cascadeRef$current2 = cascadeRef.current) === null || _cascadeRef$current2 === void 0 ? void 0 : (_cascadeRef$current2$ = _cascadeRef$current2.getBoundingClientRect) === null || _cascadeRef$current2$ === void 0 ? void 0 : (_cascadeRef$current2$2 = _cascadeRef$current2$.call(_cascadeRef$current2)) === null || _cascadeRef$current2$2 === void 0 ? void 0 : _cascadeRef$current2$2.height)
      },
      popperOptions: {
        modifiers: {
          flip: {
            enabled: false
          }
        }
      },
      paperProps: {
        style: {
          maxHeight: window.innerHeight - (cascadeRef === null || cascadeRef === void 0 ? void 0 : (_cascadeRef$current3 = cascadeRef.current) === null || _cascadeRef$current3 === void 0 ? void 0 : (_cascadeRef$current3$ = _cascadeRef$current3.getBoundingClientRect) === null || _cascadeRef$current3$ === void 0 ? void 0 : (_cascadeRef$current3$2 = _cascadeRef$current3$.call(_cascadeRef$current3)) === null || _cascadeRef$current3$2 === void 0 ? void 0 : _cascadeRef$current3$2.top) - 10,
          overflow: 'auto'
        }
      }
    }, children));
  }

  return /*#__PURE__*/_react.default.createElement(_core.FormControl, {
    variant: "outlined",
    fullWidth: size === 'full'
  }, /*#__PURE__*/_react.default.createElement(_core.InputLabel, {
    className: error && classes.label
  }, label), /*#__PURE__*/_react.default.createElement(_core.Select, {
    value: value,
    onChange: onChange,
    label: label,
    disabled: disabled,
    error: error,
    IconComponent: iconComponent,
    className: classes.input,
    size: size,
    style: {
      width: (0, _utils.checkSize)(size)
    }
  }, children), /*#__PURE__*/_react.default.createElement(_core.FormHelperText, {
    className: error ? classes.textError : ''
  }, helperText));
};

exports.SelectSaraiva = SelectSaraiva;
SelectSaraiva.propTypes = {
  /**
   * Seleciona o tamanho do input
   */
  size: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'full']),

  /**
   * Se true, o input fica desabilitado (cinza e sem poder ser acessado)
   */
  disabled: _propTypes.default.bool,

  /**
   * Se true, o contorno do Input fica vermelho
   */
  error: _propTypes.default.bool,

  /**
   * icone que irá substituir a seta lateral, caso necessário
   */
  // eslint-disable-next-line react/require-default-props
  iconComponent: _propTypes.default.element,

  /**
   * Label que fica como placeholder no input e que fica sobre o input ao ser selecionado
   */
  label: _propTypes.default.string,

  /**
   * Texto de auxilio que fica abaixo do input de select
   */
  helperText: _propTypes.default.string,

  /**
   * Objeto para adicionar as opções do select, sejam MenuItems, Calendário ou outros
   */
  children: _propTypes.default.node,

  /**
   * Função para determinar qual estado está selecionado
   */
  onChange: _propTypes.default.func,

  /**
   * Valor do input
   */
  value: _propTypes.default.string,

  /**
   * Ativa um tipo diferente de Select que suporta itens cascatas
   */
  cascade: _propTypes.default.bool,

  /**
   * Para Select Cascata é possível escolher o que aparecer de label quando existe um item selecionado
   */
  selectedLabel: _propTypes.default.string,

  /**
   * Classe css para o botão
   */
  className: _propTypes.default.string
};
SelectSaraiva.defaultProps = {
  disabled: false,
  error: false,
  label: 'Teste',
  helperText: '',
  onChange: null,
  value: '',
  children: '',
  size: 'sm',
  cascade: false,
  selectedLabel: null,
  className: null
};
var _default = SelectSaraiva;
exports.default = _default;